import { IntlFormatters } from '@formatjs/intl';
import { openNotification, response_type } from '../http-worker/http-func';

interface custom_warning_args_type {
  /** 調用 API 返回的值（可直接從 http-func 傳入） */
  response_new: response_type;
  /** 本次請求的名稱（可直接從 http-func 傳入） */
  key: string;
  /** 多語言（可直接從頁面傳入） */
  formatMessage: IntlFormatters['formatMessage'];
  /** 成功訊息 */
  success_message: string;
  /** 失敗訊息 */
  error_message: string;
}

/**
 * 範例：
 * ```ts
 * http_request_new({
 *   ......
 *   custom_warning: (response_new: response_type) =>
 *     custom_warning({
 *       response_new,
 *       key,
 *       formatMessage,
 *       success_message: 'user_role_has_been_binded_successfully',
 *       error_message: 'failed_to_bind_role_to_this_user'
 *     })
 * });
 * ```
 */
export default function custom_warning({ response_new, key, formatMessage, success_message, error_message }: custom_warning_args_type) {
  if (response_new) {
    if (response_new.code && response_new.code >= 400) {
      openNotification('error', response_new.reason ? response_new.reason : response_new.error, response_new.message);
    } else if (key !== 'auth') {
      openNotification('success', formatMessage?.({ id: 'successful' }), success_message? formatMessage({ id: success_message }):'');
    }
  } else {
    openNotification('error', formatMessage({ id: 'error' }), formatMessage({ id: error_message }));
  }
}
